import { ComparisonResult, ScenarioSummary } from './types.js';
import { roundCents } from './rounding.js';

export function compare(base: ScenarioSummary, other: ScenarioSummary): ComparisonResult {
  const savingsVsBase = roundCents(base.totalInterest - other.totalInterest);
  const termDeltaMonths = other.actualTermMonths - base.actualTermMonths;
  const maxPaymentDelta = roundCents(other.maxMonthlyPayment - base.maxMonthlyPayment);
  return {
    baseId: base.scenarioId,
    otherId: other.scenarioId,
    savingsVsBase,
    termDeltaMonths,
    maxPaymentDelta,
  };
}
